import { STRIPE_PUBLIC_KEY } from 'Config/constants'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { get } from 'lodash'
import React, { useMemo } from 'react'

interface Props {
  user: {
    id: number
    company: {
      idStripeAccount: string | null
    }
  }
  children: React.ReactNode
}


const StripeElementsWrapper = ({ user, children }: Props) => {
  const stripeAccount = get(user, 'company.idStripeAccount', undefined)
  const stripePromise = useMemo(() => loadStripe(
    STRIPE_PUBLIC_KEY,
    {
      locale: 'fr-FR',
      ...(stripeAccount ? { stripeAccount } : {}),
    },
  ), [stripeAccount])

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  )
}

export default StripeElementsWrapper